import React from 'react';
import { Typography } from 'housecall-ui';

import { ServiceList } from '../components/ServicesList';

export const ServiceStep = () => {
  return (
    <>
      <Typography gutterBottom variant="h5">
        What service do you need?
      </Typography>
      <Typography gutterBottom variant="body1">
        Please select the type of service.
      </Typography>
      <ServiceList />
    </>
  );
};
